import React from 'react';
import PropTypes from 'prop-types';
import Isvg from 'react-inlinesvg';
import { keys } from 'lodash';

import actions from '../../assets/images/icons/ico_more.svg';
import certificates from '../../assets/images/icons/ico_actions_certs.svg';
import classes from '../../assets/images/icons/icon_classes.svg';
import copy from '../../assets/images/icons/ico_move_copy.svg';
import download from '../../assets/images/icons/ico_cards.svg';
import edit from '../../assets/images/icons/ico_pencil.svg';
import excel from '../../assets/images/icons/ico_action_excel.svg';
import groupmaximise from '../../assets/images/icons/ico_groups_expand.svg';
import groupminimise from '../../assets/images/icons/ico_groups_minimise.svg';
import infocircle from '../../assets/images/icons/ico_icon_video.svg';
import maximise from '../../assets/images/icons/ico_maximise_dark.svg';
import minimise from '../../assets/images/icons/ico_minimise_dark.svg';
import movedouble from '../../assets/images/icons/ico_move.svg';
import moveright from '../../assets/images/icons/ico_move_arrow.svg';
import plus from '../../assets/images/icons/ico_plus.svg';
// Can't be just 'new'
import newIcon from '../../assets/images/icons/ico_new.svg';
import movecopy from '../../assets/images/icons/ico_movecopy.svg';
import remove from '../../assets/images/icons/ico_move_remove.svg';
import sortdown from '../../assets/images/icons/ico_sort_down.svg';
import sortup from '../../assets/images/icons/ico_sort_up.svg';
import threeEssentials from '../../assets/images/icons/ico_three_essentials.svg';
import arrow from '../../assets/images/icons/ico_arrow.svg';
import manageStudents from '../../assets/images/icons/ico_manage_students.svg';
import successIcon from '../../assets/images/icons/ico_success.svg';
import groupIcon from '../../assets/images/icons/ico_groups.svg';
import editIcon from '../../assets/images/icons/ico_edit.svg';
import personIcon from '../../assets/images/icons/ico_person.svg';
import closeIcon from '../../assets/images/icons/ico_close.svg';
import lightningBoltIcon from '../../assets/images/icons/ico_lightning_bolt.svg';

const assets = {
    actions,
    certificates,
    plus,
    classes,
    copy,
    download,
    edit,
    excel,
    groupmaximise,
    groupminimise,
    infocircle,
    maximise,
    minimise,
    movedouble,
    moveright,
    newIcon,
    movecopy,
    remove,
    sortdown,
    sortup,
    arrow,
    threeEssentials,
    manageStudents,
    successIcon,
    groupIcon,
    editIcon,
    personIcon,
    closeIcon,
    lightningBoltIcon
};
const ASSET_NAMES = keys(assets);

const ImageAsset = ({ parentTitle, parentClass, type }) => {
    let asset = '';
    const svgSrc = assets[type];
    switch (type) {
        default:
            if (svgSrc) {
                asset = <Isvg cacheGetRequests src={svgSrc} />;
            }
    }
    return (
        <span title={parentTitle} className={`${parentClass || 'image-asset'}`}>
            {asset}
        </span>
    );
};

ImageAsset.propTypes = {
    parentTitle: PropTypes.string,
    parentClass: PropTypes.string,
    type: PropTypes.oneOf(ASSET_NAMES).isRequired
};

export default ImageAsset;



// WEBPACK FOOTER //
// ./components/image-asset/image-asset.js